module.exports = "<form class=inp-ref @submit.prevent.stop=submit @keydown=keydown @click.stop> <div v-if=prop v-text=propText></div> <div v-if=value v-text=valueText></div> <input type=text :class={focus:term||prop} v-model=term :placeholder=\"prop?'something':'link'\" @click=input @focus=input @input=input> <div class=ref-select v-if=options> <div class=ref-option :class=\"{'ref-ghost':$index===ghost}\" v-for=\"opt in options\" v-text=text(opt) track-by=$index @mouseenter=\"ghost=$index\" @mousedown=confirm(opt) transition=staggered></div> </div> </form>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/InputRef.vue
 ** module id = 137
 ** module chunks = 0
 **/